import styled, { css } from "styled-components";

const PageTitle = styled.p`
  margin-bottom: 0;
  color: ${props => props.theme.black};
  font-weight: bold;

  ${props => {
    return (
      props.withPadding &&
      css`
        padding-right: 6.5rem;
      `
    );
  }}
`;

export default PageTitle;
